import React, { useEffect, useState } from 'react'
import Helper from '../Helper'
import Loader from '../Loader/Loader';
import useStateRef from 'react-usestateref';
import { Link } from 'react-router-dom';

const CbLoginModal = (props) => {

    const [isLoading, setIsLoading] = useState(false);
    const [hasError, setHasError, setHasErrorRef] = useStateRef(false);
    const [errorMessage, setErrorMessage] = useState();
    const [triggerModal, setTriggerModal] = useState(props && props.triggerAddToList?props.triggerAddToList:false);
    const [productId, setProductId] = useState(props && props.productId?props.productId:"");
   function reload(){
    var btnEle =  document.getElementById("form-login");
    if (btnEle) {
      btnEle.reset();       
    }
   }



    const validateLoginForm = (key, value) => {
        switch (key) {
            case "username":
                var validation = "^[A-Za-z0-9._%+-]+@(?:[A-Za-z0-9-]+\\.)+[A-Za-z]{2,6}$";
                var regex = RegExp(validation);
                var result = Helper.isEmpty(value)
                if (result) {
                    setHasError(true)
                    document.getElementById("login-modal-error-div").classList.remove("d-none")
                    document.getElementById("login-modal-error-div").classList.add("d-block")
                    document.getElementById("username").classList.add("form-error")
                    var emptylogin = document.getElementById("username_error-modal")
                    emptylogin.innerHTML = "Email is a required field.";
                } else if (!regex.test(value)) {
                    setHasError(true)
                    document.getElementById("login-modal-error-div").classList.remove("d-none")
                    document.getElementById("login-modal-error-div").classList.add("d-block")
                    document.getElementById("username").classList.add("form-error")
                    var emptypassword = document.getElementById("username_error-modal")
                    emptypassword.innerHTML = "Email address is invalid. Please try again";
                } else {
                    var emptyFirstName = document.getElementById("username_error-modal")
                    emptyFirstName.innerHTML = "";
                }
                break;
            case "password":
                 var result = Helper.isEmpty(value)
                if (result) {
                    setHasError(true)
                    document.getElementById("login-modal-error-div").classList.remove("d-none")
                    document.getElementById("login-modal-error-div").classList.add("d-block")
                    document.getElementById("password").classList.add("form-error")
                    var emptypassword = document.getElementById("password_error-modal")
                    emptypassword.innerHTML = "Password is a required field.";
                } else {
                    var emptyFirstName = document.getElementById("password_error-modal")
                    emptyFirstName.innerHTML = "";
                }
                break;

            default:
        }
    }

    const clearErrorMsg = () => {
        document.getElementById("login-modal-error").innerHTML = "";
        document.getElementById("login-modal-error-div").classList.add("d-none");
        document.getElementById("username").classList.remove("form-error")
        document.getElementById("password").classList.remove("form-error")
    }

    function closeButton() {
        clearErrorMsg();

    }
    const handleSubmit = (event) => {
        event.preventDefault();
        clearErrorMsg();
        setIsLoading(false)
        setHasError(false)
        var actionUrl = event.target.getAttribute('action');
        var formId = event.target.id;
        
        var formData = new FormData(event.target);
        const formValue = Object.fromEntries(formData.entries());
        
        Object.entries(formValue).map(([key, value], keyIndex) => {
           validateLoginForm(key, value)
        })
        var username = formData.get("username")
        var password = formData.get("password")
        const inputMap = {
            username: username,
            password: password
        }


        if (!setHasErrorRef.current) {

            // setIsLoading(true)
            fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/profile/${actionUrl}`, {
                method: 'POST',
                headers: new Headers({
                    "content-Type": "application/json",
                }),
                body: JSON.stringify(inputMap)
            }).then(res => res.json())
                .then(res => {
                    if (res.result === "success") {
                        setIsLoading(false)
                         if(triggerModal=== false){
                        window.location.href = "/"
                        }
                        else if(triggerModal === true){
                            props.triggerAddToListModals(true)
                           document.getElementById("btn-close-login").click();

                           const afterLoginAddToList= document.getElementById("afterLoginAddToList")
                           if(afterLoginAddToList != " "){
                            afterLoginAddToList.click();
                           }
                            
                        }

                    } else {
                        setIsLoading(false)
                        const error = res._ERROR_MESSAGE_;
                        setErrorMessage(error);
                        document.getElementById("login-modal-error-div").classList.remove("d-none");
                        
                    }
                })
        }

    }


  return (
    
    <div className="modal fade" onClick={closeButton} id="loginModal" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabindex="-1">
    {isLoading ? <Loader /> : ""}
        <div class="modal-dialog modal-dialog-centered">
            <div className="modal-content">
                <button type="button" onClick={closeButton} class="btn-close login" data-bs-dismiss="modal" aria-label="Close" id="btn-close-login">
                </button>
                <div class="modal-body">

                    <div class="container-fluid login-modal-body">
                        <div class="row">
                            <div class="col-12 mb-3">
                                <h3 class="modal-title login mb-3" id="defaultModalLabel">Log In</h3>
                                <p class="modal-sub-heading m-0">
                                    Please enter your email address and password to access your account.
                                </p>
                                
                            </div>
                            <div class="col-12 success-err-fs">
                                    <div id="login-modal-success-div" className='d-none alert alert-success'>
                                        <div id="login-modal-success"></div>
                                    </div>
                                    <div id="login-modal-error-div" className='d-none alert alert-danger login-error-msg'>
                                        <div id="login-modal-error" dangerouslySetInnerHTML={{ __html: errorMessage }}></div>

                                        <div id="username_error-modal"></div>
                                        <div id="password_error-modal"></div>
                                    </div>

                                </div>

                            <form method="post" action="login" id="form-login" class="col-12 form" data-hs-cf-bound="true" onSubmit={handleSubmit}>
                                <div style={{ display: 'none' }}>
                                    <input name="_dyncharset" type="hidden" value="UTF-8" />
                                </div>
                                <div style={{ display: 'none' }}>
                                    <input name="" type="hidden" />
                                </div>
                                <div class="row mb-3 align-items-center">
                                    <label for="login-email" class="col-12 col-md-3 col-form-label">Email:</label>
                                    <div class="col-12 col-md-7">
                                        <input maxlength="256"  name="username" id="username" type="email" class="form-control" onkeypress="" />
                                        
                                    </div>
                                </div>
                                <div class="row mb-3 align-items-center">
                                    <label for="password" class="col-12 col-md-3 col-form-label">Password:</label>
                                    <div class="col-12 col-md-7">
                                        <input maxlength="40" name="password" id="password" type="password" class="form-control" onkeypress="" _ar_hide_="width:247.817px;height:32px;margin:0px;position:static;display:block;" />
                                        
                                    </div>
                                </div>
                                <div class="row mb-3 align-items-center m-hidden">
                                    <div class="col-12 col-md-7 offset-md-3">
                                        <div class="form-check">
                                            <input name="" id="rememberMe" type="checkbox" value="true" class="form-check-input" />
                                            <input name="" type="hidden" value=" " />
                                            <label class="form-check-label" for="remember-check">
                                                Remember Me
                                            </label>
                                        </div>
                                    </div>
                                </div>


                                <div class="row align-items-center form-submit">
                                    <div class="col-12 col-md-6 mb-3">

                                    </div>
                                    <div class="col-12 col-md-6 text-center text-md-end">
                                        <Link to="/account/login" class="btn btn-secondary register me-2">Register</Link>
                                        <input class="btn btn-primary login" value="Log In" type="submit" />
                                    </div>
                                </div>
                            </form>
                            <button class="forgetPwd-btn" data-bs-target="#modalForgetPassword" data-bs-toggle="modal" data-bs-dismiss="modal">Forgot Password?</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default CbLoginModal